import { Link } from 'react-router-dom';

const TermsOfUsePage = () => {
  return (
    <section className="bg-[#fffaf5] py-24">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6 lg:px-8">
        <article className="rounded-3xl border border-orange-100 bg-white p-6 shadow-sm sm:p-8 lg:p-10">
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-orange-600">Legal</p>
          <h1 className="mt-2 text-4xl font-semibold text-slate-900">Terms and Conditions of Use</h1>
          <p className="mt-3 text-sm text-slate-600">
            This website assists writers, poets, publishers, and producers of audio stories in local languages to share, exchange, and trade with one another and with consumers.
          </p>

          <div className="mt-8 space-y-8 text-sm leading-7 text-slate-700">
            <section>
              <p>
                By visiting this website, you acknowledge that we gather listening and transaction-related information to support lawful service delivery with audio and content suppliers.
              </p>
              <p className="mt-2">Please read these Terms carefully.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-900">Content ownership and responsibility</h2>
              <p className="mt-2">
                By uploading, sharing, or selling audio content on this website, you confirm you have all necessary rights and you accept full responsibility for your content.
              </p>
              <p className="mt-2">
                The platform and its owners are not liable for user-generated content shared or consumed through this service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-900">Acceptance of terms</h2>
              <p className="mt-2">
                By accessing or using this website, or listening to or using any product/service on it, you agree to these Terms and Conditions of Use.
              </p>
              <p className="mt-2">If you do not agree, please do not use this website or any audio content provided through it.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-900">Use of the website</h2>
              <p className="mt-2">As a condition of use, you warrant that:</p>
              <ul className="mt-2 list-disc space-y-2 pl-6">
                <li>You are at least 18 years old and of sound mind. If under 18, you must have legal guardian consent.</li>
                <li>You will use this website in accordance with these Terms.</li>
                <li>You will only use this website for legitimate listening, sharing, or transactions for yourself or another person you are legally authorized to represent.</li>
                <li>You will inform any represented person of all applicable rules and restrictions.</li>
                <li>All information you submit is accurate, current, and complete.</li>
                <li>If you have an account, you will protect your account credentials and accept full responsibility for all activity under your account.</li>
              </ul>
              <p className="mt-2">
                We may deny access to this website or services at any time without notice where these Terms are violated.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-900">Purchase</h2>
              <p className="mt-2">
                For paid content added by third-party publishers on the HAAPA platform, HAAPA retains 30% of the retail price. For free content, HAAPA retains 0%.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-900">Refund</h2>
              <p className="mt-2">
                Refund policy is determined by suppliers (writers, poets, publishers, and producers) who publish on HAAPA web/apps.
              </p>
              <p className="mt-2">
                Please review each product's listening/sharing policy before payment. Contact support any time for clarification.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-900">Prohibited activities</h2>
              <ul className="mt-2 list-disc space-y-2 pl-6">
                <li>Using this website for terrorism, homophobia, or any human-rights violations.</li>
                <li>Making speculative, false, or fraudulent audio publication.</li>
                <li>Accessing, monitoring, or copying content without written permission.</li>
                <li>Taking actions that impose unreasonable load on platform infrastructure.</li>
                <li>Deep-linking any portion of this website without express written permission.</li>
                <li>Embedding/incorporating any part of this website into another site without prior written authorization.</li>
                <li>Modifying, copying, distributing, transmitting, publishing, licensing, creating derivative works from, transferring, selling, or reselling data/software/products/services obtained through this website, except limited personal copies of your own lawful routines/documents.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-900">Fraud and account closure</h2>
              <p className="mt-2">
                If your account shows fraud, abuse, or suspicious activity, we may cancel listening/sharing activity linked to your name, email, or account and close associated accounts.
              </p>
              <p className="mt-2">
                We reserve the right to take legal action for fraudulent activity, including claims for monetary losses, litigation costs, and damages.
              </p>
              <p className="mt-2">To contest account closure or cancellation, contact customer support.</p>
            </section>
          </div>

          <div className="mt-10 flex flex-wrap gap-3 border-t border-orange-100 pt-6">
            <Link to="/privacy-policy" className="rounded-xl border border-orange-200 px-4 py-2 text-sm font-semibold text-orange-700 transition hover:bg-orange-50">
              View Privacy Policy
            </Link>
            <Link to="/" className="rounded-xl bg-orange-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-orange-700">
              Back Home
            </Link>
          </div>
        </article>
      </div>
    </section>
  );
};

export default TermsOfUsePage;
